// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b8","footer":"b9","subscriptionsList":"b-","disclaimer":"b_"};